import { render, staticRenderFns } from "./form-pindaan-harta_alih.vue?vue&type=template&id=009c50d5&"
import script from "./form-pindaan-harta_alih.vue?vue&type=script&lang=js&"
export * from "./form-pindaan-harta_alih.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports